import React, { useState, useEffect } from 'react';
import $ from 'jquery'
import Toastr from 'toastr'
import SessionManager from '../../routes/SessionManager';
import Loading from '../Loading';
import { Select } from 'antd';
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

function UserModal(props) {

    let sessionManager = new SessionManager();
    let templates = sessionManager.readCookie('templates', false);
    let userObj = sessionManager.readCookie('user', false);
    let usertemplate = null;
    if (templates && templates.user)
        usertemplate = templates.user;

    const [user, setUser] = useState(null);
    const [roles, setRoles] = useState([]);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
    const [sites, setSites] = useState([]);
    const [user_template, setUserTemplate] = useState(usertemplate);
    const [sf_acc_id, setSfAccId] = useState(null);
    const [isModified, setIsModified] = useState(false);
    const [user_original, setUserOriginal] = useState({});

    let customer_id = userObj.customer_id;

    useEffect(() => {
        fetchSiteSuptUIRoles();
        fetchCustomerInfo();
    }, []);

    var textFormatter = (obj) => {
        let el =
            <div className="col-md-6" key={obj.field}>
                <label className="text-primary">{obj.label}</label>
                <input style={{ width: "14rem" }} autoComplete="off" className={obj.required ? "form-control required" : "form-control"} type={obj.type} value={props.title === "Create User" && obj.field.indexOf("user_pass") !== -1 && (user[obj.field] == null || user[obj.field] === undefined || user[obj.field].length === 0) ? (obj.default || "") : (user[obj.field] || "")} name={obj.field} id={obj.field} onChange={handleInputChange} placeholder={obj.label} disabled={obj.disabled || false} />
                {obj.field === 'user_pass_new' && <i className={isPasswordVisible ? "fa fa-eye user-password-icon" : "fa fa-eye-slash user-password-icon"} onClick={() => togglePasswordVisiblity('pwd')}></i>}
                {obj.field === 'user_pass_confirm' && <i className={isConfirmPasswordVisible ? "fa fa-eye user-password-icon" : "fa fa-eye-slash user-password-icon"} onClick={() => togglePasswordVisiblity('confirm_pwd')}></i>}
                {obj.required && <div className="invalid-feedback required">{obj.label} is required</div>}
            </div>;
        return el;
    }

    const dropdownFormatter = (obj) => {
        const isMulti = obj.type === 'Multiselect';
        const availableOptions = Array.isArray(obj.options) ? obj.options : obj.options === 'roles' ? roles : sites;
        const rawValue = user[obj.field];
        const selectValue = isMulti
            ? (Array.isArray(rawValue) ? rawValue.map(function (v) { return v + ''; }) : [])
            : (rawValue != null ? rawValue + '' : undefined);

        return <div className="col-md-6" key={obj.field}>
            <label className="has-float-label text-primary">{obj.label}</label>
            <Select
                className={obj.required ? "form-control required" : "form-control"}
                style={{ width: "14rem" }}
                placeholder={obj.placeholder}
                name={obj.field}
                id={obj.field}
                mode={isMulti ? "multiple" : undefined}
                options={availableOptions}
                value={selectValue}
                onChange={(val) => handleMultipleSelect(val, obj)} />
            {obj.required && <div className="invalid-feedback required">{obj.label} is required</div>}
        </div>;
    }

    const isEditMode = !!props.user;

    let form_template = [
        { field: 'user_name', label: 'User Name *', type: 'text', formatAs: textFormatter, regex: '', required: true },
        { field: 'user_login', label: 'User ID *', type: 'email', formatAs: textFormatter, regex: '', required: true, disabled: isEditMode },
        { field: 'user_pass_new', label: isEditMode ? 'New Password' : 'Password *', type: 'password', formatAs: textFormatter, regex: '', required: !isEditMode, },
        { field: 'user_pass_confirm', label: isEditMode ? 'Confirm New Password' : 'Confirm Password *', type: 'password', formatAs: textFormatter, regex: '', required: !isEditMode, },
        { field: 'user_phone1', label: 'Phone', type: 'phone', formatAs: textFormatter, regex: '' },
        { field: 'user_state', label: 'Status *', placeholder: 'Choose Status', type: 'select', formatAs: dropdownFormatter, regex: '', required: true, options: [{ label: 'Active', value: 'Active' }, { label: 'Inactive', value: 'Inactive' }] },
        { field: 'user_role', label: 'Roles *', placeholder: 'Choose Role', type: 'select', formatAs: dropdownFormatter, regex: '', required: true, options: 'roles' },
        { field: 'user_sites', label: 'Sites *', placeholder: 'Choose Site(s)', type: 'Multiselect', formatAs: dropdownFormatter, regex: '', required: true, options: 'sites' },
        { field: 'user_phone2', label: '', type: 'hidden', formatAs: textFormatter, regex: '' },
        { field: 'user_email1', label: '', type: 'hidden', formatAs: textFormatter, regex: '' },
        { field: 'user_email2', label: '', type: 'hidden', formatAs: textFormatter, regex: '' },
    ];

    const fetchCustomerInfo = () => {
        var data = {
            user_login: userObj.user_login,
            user_token: userObj.user_token,
            criteria: {
                from: 0,
                size: 1000,
                customer_id: customer_id
            },
            attributes: "customer_id,sf_acc_id"
        }
        CommonUtils.ajax(
            {
                url: API.COMMON_TABLE_OPERATIONS.CUSTOMER.FETCH,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    setSfAccId(res.data.records[0].sf_acc_id);
                } else {
                    Toastr.error('Token Expired!')
                }
            }
        )
    }

    const fetchSiteSuptUIRoles = () => {
        let data = {
            "source": "D",
            "criteria": { "from": 0, "size": 1000, "dom_id": "SITESUPT-UI-ROLE" },
            "user_login": userObj.user_login,
            "user_token": userObj.user_token,
            "user_type": "user"
        };

        CommonUtils.ajax({
            url: API.COMMON_TABLE_OPERATIONS.DOM.FETCH,
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data)
        }).then(
            res => {
                if (res.status && res.status.code === 200) {
                    let roles = [];
                    let allowedRoles = ["1", "2", "3", "4"];
                    for (let role of res.data.records) {
                        if (allowedRoles.indexOf(role.dom_key) > -1) {
                            roles.push({ label: role.dom_val, value: role.dom_key });
                        }
                    }
                    setRoles(roles);
                    loadPageContent();
                } else {
                    loadPageContent();
                }
            }
        );
    }

    const loadPageContent = () => {
        if (!user_template) {
            let data = {
                "source": "M",
                "criteria": { "from": 0, "size": 10, "user_login": 'SITESUPT_TEMPLATE' },
                "user_login": userObj.user_login,
                "user_token": userObj.user_token,
                "user_type": "user"
            };

            CommonUtils.ajax({
                url: API.COMMON_TABLE_OPERATIONS.USER.FETCH,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }).then(
                res => {
                    if (res.status && res.status.code === 200) {
                        if (res.data && res.data.records.length > 0) {
                            setUserTemplate(res.data.records[0].record);
                        }
                    }
                },
            );
        } else {
            prepareUserData();
        }
    }

    useEffect(() => {
        if (user_template !== null) {
            let templates = sessionManager.readCookie('templates', false);
            if (!templates)
                templates = {};
            templates.user = user_template;
            templates.user.user_login = '';
            sessionManager.storeCookie('templates', templates);
            prepareUserData();
        }
    }, [user_template]);

    const togglePasswordVisiblity = (type) => {
        if (type === 'pwd') {
            const isPassword_Visible = isPasswordVisible;
            let user_pass_new = document.getElementById('user_pass_new');
            user_pass_new.type = user_pass_new.type === 'password' ? 'text' : 'password';
            setIsPasswordVisible(!isPassword_Visible);
        } else {
            const isConfirmPassword_Visible = isConfirmPasswordVisible;
            let user_pass_confirm = document.getElementById('user_pass_confirm');
            user_pass_confirm.type = user_pass_confirm.type === 'password' ? 'text' : 'password';
            setIsConfirmPasswordVisible(!isConfirmPassword_Visible);
        }
    }

    const prepareUserData = () => {
        if (props.user) {
            let _user = JSON.parse(JSON.stringify(props.user));
            _user.user_pass_new = '';
            _user.user_pass_confirm = '';
            if (!_user.user_state) _user.user_state = 'Active';
            let siteOptions = props.customerSites
                ? props.customerSites.map(function (s) { return { value: s.site_id, label: s.site_name }; })
                : [{ value: userObj.site_selected.site_id, label: userObj.site_selected.site_name }];
            setSites(siteOptions);
            setUserOriginal(JSON.parse(JSON.stringify(props.user)));
            setIsModified(false);
            setUser(_user);
        } else {
            let _user = JSON.parse(JSON.stringify(user_template));
            _user.customer_id = userObj.customer_id;
            let siteOptions = [];
            siteOptions.push({ value: userObj.site_selected.site_id, label: userObj.site_selected.site_name });
            _user.user_sites = [userObj.site_selected.site_id];
            if (!_user.user_state) _user.user_state = 'Active';
            setSites(siteOptions);
            setIsModified(true);
            setUserOriginal({});
            setUser(_user);
        }
    }

    const closeModal = () => {
        props.toggleEditUser({});
    }

    const handleInputChange = ({ target }) => {
        let _user = { ...user }
        if (target.name === "user_phone1") {
            _user["user_phone2"] = target.value;
        }
        if (target.name === "user_login") {
            _user["user_email1"] = target.value;
            _user["user_email2"] = target.value;
        }
        _user[target.name] = target.value;
        let modifiedAtts = getModifiedAttributes(_user);
        setUser(_user);
        setIsModified(Object.keys(modifiedAtts).length > 0);
        // console.log(user)
        if ($(target).hasClass("required"))
            if (target.value === "")
                $(target).addClass("is-invalid")
            else
                $(target).removeClass("is-invalid");
    }

    const handleMultipleSelect = (val, obj) => {
        let _user = { ...user };
        if (obj.type === 'Multiselect') {
            _user[obj.field] = Array.isArray(val) ? val : [val];
        } else {
            _user[obj.field] = val;
        }
        let modifiedAtts = getModifiedAttributes(_user);
        setUser(_user);
        setIsModified(Object.keys(modifiedAtts).length > 0);
    }

    const saveUser = () => {
        CommonUtils.validateForm().then(resolved => {
            let _user = getModifiedAttributes(user);
            if (_user.user_role === 1) {
                $('[name="user_role"]').addClass("is-invalid");
                return
            }
            if (_user.user_sites && _user.user_sites[0] === '0') {
                $('[name="user_sites"]').addClass("is-invalid");
                return
            }
            let regexPattern = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

            if (_user.user_login && !CommonUtils.validateEmail(_user.user_login)) {
                return Toastr.error('Enter valid email as user id');
            }

            if (!regexPattern.test(user.user_phone1) && user.user_phone1 !== "") {
                return Toastr.error('Enter valid phone');
            }

            const userLoginValue = props.user ? props.user.user_login : user.user_login;
            let userIdRegexPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!userIdRegexPattern.test(userLoginValue)) {
                return Toastr.error('Enter valid User ID');
            }

            if ((_user.user_pass_new || _user.user_pass_confirm) && _user.user_pass_new !== _user.user_pass_confirm) {
                Toastr.error('Password, Confirm Password not matching');
                return;
            }

            delete _user.user_pass_confirm;
            delete _user.user_pass_new;

            if (!props.user) {
                _user.user_pass = user.user_pass_new ? user.user_pass_new.trim() : (props.customer && props.customer.customer_def_pass);
            } else if (user.user_pass_new && user.user_pass_new.trim().length > 0) {
                _user.user_pass = user.user_pass_new.trim();
            }

            _user.user_login = userLoginValue.trim().toLowerCase();

            if (_user.user_role)
                _user.user_role = parseInt(_user.user_role);

            if (sf_acc_id) {
                _user.sf_acc_id = sf_acc_id;
            }

            let userSession = sessionManager.readCookie('user');
            _user.user_lastupdate = CommonUtils.getUTCTimestampNow();
            _user.modified_by = userSession.user_name;
            _user.user_type = "user";

            const url = props.user ? API.COMMON_TABLE_OPERATIONS.USER.MODIFY : API.COMMON_TABLE_OPERATIONS.USER.CREATE;
            let data = {
                "form_input": _user,
                "user_login": userObj.user_login,
                "user_token": userObj.user_token,
                "user_type": "user"
            };
            CommonUtils.ajax({
                url,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }).then((res) => {
                if (res.status && res.status.code === 200) {
                    $("#save_user").toggleClass("btn-loading disabled");
                    $("#save_user").removeAttr("disabled");
                    closeModal({});
                    props.updateUser();
                    Toastr.success(props.user ? "User updated successfully !" : "User created successfully !");
                } else {
                    Toastr.error(props.user ? "Failed to update user !" : "An account with same user id already exists !");
                    $("#save_user").removeAttr("disabled");
                }
            });

        }, () => {
            Toastr.error('Please correct validation errors to continue ...', 'Error');
            $("#save_user").removeClass("btn-loading disabled");
            $("#save_user").removeAttr("disabled");
        }).catch(() => {
            $("#save_user").removeClass("btn-loading disabled");
            $("#save_user").removeAttr("disabled");
        });
    }

    const getModifiedAttributes = (c1 = user) => {
        let c0 = user_original;
        let modifiedAtts = {};
        for (let k in c1) {
            if (c0[k] === undefined || c1[k] + '' !== c0[k] + '') {
                if (typeof c1[k] === 'string')
                    c1[k] = (c1[k] + '');
                modifiedAtts[k] = c1[k];
            }
        }
        // console.log('Modified Attributes : ', modifiedAtts);
        return modifiedAtts;
    }

    return (
        <React.Fragment>
            {user ?
                <React.Fragment>
                    <div className="modal-body">
                        <div className="row px-2">
                            {form_template.map((f) => {
                                return f.formatAs(f)
                            })}
                        </div>
                    </div>

                    <div className="modal-footer mt-4">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => closeModal({})}> Cancel </button>
                        <button id="save_user" disabled={!isModified} className={"btn btn-primary"} onClick={saveUser}>{props.user ? "Update User" : "Save User"}</button>
                    </div>
                </React.Fragment>
                :
                <div className="modal-body my-3">
                    <Loading>Loading user information ...</Loading>
                </div>
            }
        </React.Fragment>
    );
}

export default UserModal;